"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScraperType = void 0;
var ScraperType;
(function (ScraperType) {
    ScraperType["BROWSER"] = "browser";
    ScraperType["MOBILE_API"] = "mobileApi";
    ScraperType["EMULATOR"] = "emulator";
})(ScraperType = exports.ScraperType || (exports.ScraperType = {}));
